import PermissionsRender from './PermissionsRender';

export default PermissionsRender;
